import { Component } from '@angular/core';

@Component({
  selector: 'app-hospitals',
  standalone: true,
  imports: [],
  templateUrl: './hospitals.component.html',
  styleUrl: './hospitals.component.scss'
})
export class HospitalsComponent {

}
